import { createContext, use } from 'react';

import type { SiteInventoryHealth } from '@restDataAccess';

import type { SiteWithApis } from '@/stores';

export type SiteContextType = {
  sites: SiteWithApis[];
  currentSite?: SiteWithApis;
  health?: SiteInventoryHealth;
  /** True once the accessible-site list has been fetched. The list may still be empty; this only
   * signals that loading has settled so consumers can distinguish "no sites" from "still loading". */
  areSitesResolved: boolean;
  /** Portable mode: stored selection is missing or not a `getDistinctTypesBySite` key. */
  mustSelectSite: boolean;
};

export const SiteContext = createContext<SiteContextType>({
  sites: [],
  areSitesResolved: false,
  mustSelectSite: false,
});

export const useSiteContext = () => {
  return use(SiteContext);
};
